import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import Breadcrump from "../../components/Breadcrump";

function DashboardLayout() {
  return (
    <>
      <Breadcrump title="My Account" />

      <div className="vp-wrapper py-5">
        <div className="container">
          <div className="vp-dashboard-grid">
            <div className="vp-sidebar-col">
              <Sidebar />
            </div>
            <div className="vp-content-col">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;